const windowObject = () => {
    return typeof window !== 'undefined' ? window : null;
}

const createDataLayer = (project, pageCategory, pageSubCategory, pageName) => {
    return {
        pageCategory,
        pageSubCategory,
        pageName: `${pageName} ${project?.__influencerName}`,
        planId: project?.id
    }
}

const pushDataLayerToWindow = (dataLayer) => {
    const w = windowObject();

    if (w) {
        if (Array.isArray(w.dataLayer)) {
            w.dataLayer.push(dataLayer);
        }
        else {
            w.dataLayer = [dataLayer];
        }
    }
}

const addGTMDataLayerToWindow = (project, pageCategory, pageSubCategory, pageName) => {

    const dataLayer = createDataLayer(project, pageCategory, pageSubCategory, pageName);
    pushDataLayerToWindow(dataLayer);
}

const addGTMEventToWindow = (project, data) => {

    const dataLayer = {
        ...data, ...{
            planId: project?.id, formName: `Influencer ${project?.__influencerName}`
        }
    }
    pushDataLayerToWindow(dataLayer);
}

export { addGTMDataLayerToWindow, addGTMEventToWindow, pushDataLayerToWindow }
